module.exports = __webpack_public_path__ + "img/releated-none.a80c3469.svg";